import { createContext, useContext } from 'react';

export type LeadsFiltersContextType = {
  agentIds: string[];
  stageIds: string[];
};

export const LeadsFiltersContext = createContext<LeadsFiltersContextType>({
  agentIds: [],
  stageIds: [],
});

export const useLeadsFilters = () => {
  return useContext(LeadsFiltersContext);
};
